// EnvBadge — LOCAL / DEV / UAT / PROD, so nobody operates on production by mistake (task 355.3).
// Renders nothing when the environment cannot be determined (never a wrong badge).

import React from 'react';
import { currentEnvironment, type ConsoleEnvironment } from '../../theme/environment';
import styles from './EnvBadge.module.css';

interface EnvBadgeProps {
  /** Defaults to the running console's environment. */
  environment?: ConsoleEnvironment | null;
}

export default function EnvBadge({ environment }: EnvBadgeProps): React.ReactElement | null {
  const env = environment === undefined ? currentEnvironment() : environment;
  if (!env) return null;
  return (
    <span className={styles.badge} data-env={env} title={`Environment: ${env}`}>
      {env}
    </span>
  );
}
